import type { ReactNode } from "react";
import { TONE_TEXT, type Tone } from "@/components/ui/tone";
import { cn } from "@/lib/utils";

interface ResultHeadlineProps {
  label: string;
  value: string;
  detail?: ReactNode;
  tone?: Tone;
}

export function ResultHeadline({ label, value, detail, tone = "neutral" }: ResultHeadlineProps) {
  return (
    <div>
      <p className="text-sm text-muted-foreground">{label}</p>
      <p className={cn("mt-1 text-3xl font-semibold tabular-nums tracking-tight", TONE_TEXT[tone])}>
        {value}
      </p>
      {detail === undefined ? null : (
        <p className="mt-1 text-sm text-muted-foreground">{detail}</p>
      )}
    </div>
  );
}

export function ResultList({ children }: { children: ReactNode }) {
  return <dl className="divide-y divide-border border-y border-border">{children}</dl>;
}

export function ResultItem({ term, value }: { term: string; value: string }) {
  return (
    <div className="flex items-baseline justify-between gap-4 py-2.5 text-sm">
      <dt className="min-w-0 text-muted-foreground">{term}</dt>
      <dd className="shrink-0 text-right font-medium tabular-nums text-foreground">{value}</dd>
    </div>
  );
}

export function ResultMessage({ children }: { children: ReactNode }) {
  return (
    <p role="status" className="text-sm text-muted-foreground">
      {children}
    </p>
  );
}
